import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { LoginPage } from './auth/LoginPage';
import { RequireAuth } from './auth/RequireAuth';
import { Nav } from './components/Nav';
import { useI18n } from './i18n/I18nProvider';
import { TeamPage } from './pages/TeamPage';

// The pages are loaded on demand: the map and the Excel code only when needed.
const HomePage = lazy(() => import('./pages/home/HomePage'));
const HistoryPage = lazy(() => import('./pages/history/HistoryPage'));
const ManifestPage = lazy(() => import('./pages/manifest/ManifestPage'));
const ProgramsPage = lazy(() => import('./pages/programs/ProgramsPage'));
const CollectPage = lazy(() => import('./pages/collect/CollectPage'));
const StockPage = lazy(() => import('./pages/stock/StockPage'));

function Loading() {
  const { t } = useI18n();
  return (
    <div className="uco-boot">
      <span className="uco-spin" />
      {t('loading')}
    </div>
  );
}

function Shell() {
  return (
    <>
      <Nav />
      <Suspense fallback={<Loading />}>
        <Outlet />
      </Suspense>
    </>
  );
}

function NotFound() {
  const { t } = useI18n();
  return (
    <div className="pg" style={{ padding: 28 }}>
      <p className="note">{t('notFound')}</p>
      <a className="tel" href="/">
        {t('backHome')}
      </a>
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<Shell />}>
          <Route index element={<RequireAuth><HomePage /></RequireAuth>} />
          <Route path="/history" element={<RequireAuth><HistoryPage /></RequireAuth>} />
          <Route path="/manifest" element={<RequireAuth><ManifestPage /></RequireAuth>} />
          <Route path="/programs" element={<RequireAuth><ProgramsPage /></RequireAuth>} />
          <Route path="/collect" element={<RequireAuth collect><CollectPage /></RequireAuth>} />
          <Route path="/collect/:programId" element={<RequireAuth collect><CollectPage /></RequireAuth>} />
          <Route path="/stock" element={<RequireAuth><StockPage /></RequireAuth>} />
          <Route path="/team" element={<RequireAuth role="admin"><TeamPage /></RequireAuth>} />
          {/* old addresses, for bookmarks and the dev server (Cloudflare redirects them too) */}
          <Route path="/history.html" element={<Navigate to="/history" replace />} />
          <Route path="/manifest.html" element={<Navigate to="/manifest" replace />} />
          <Route path="/programs.html" element={<Navigate to="/programs" replace />} />
          <Route path="/team.html" element={<Navigate to="/team" replace />} />
          <Route path="/login.html" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
